import React, { FC, useContext } from 'react';

import { FormattedMessage } from 'react-intl';
import { Label } from 'semantic-ui-react';
import { CurrencyInput } from '../../../../components/common/form';
import { PlAN_LEVEL } from '../../../../constants/enrollmentList/enrollmentList.constant';
import { INPUT_TYPES } from '../../../../constants/inputs/inputTypes';
import { aptcAmountFieldValue } from '../common/enrollmentUtils';
import { AddOrChangeTxnFormContext } from '../context/AddOrChangeTxnProvider';
import { StyledField } from '../styles/EnrollmentSharedStyled';

const EnrollmentAPTCAmounField: FC = ({}) => {
    const { watch, setValue } = useContext(AddOrChangeTxnFormContext);
    const values = watch();

    const onAptcChange = e => {
        aptcAmountFieldValue(setValue, 'aptcAmount', e.target.value);
    };

    return (
        <StyledField>
            <Label>
                <FormattedMessage id={'member.enrollment_list.premiumhistory.aptcAmount'} />
            </Label>

            <CurrencyInput
                // @ts-ignore
                label={{
                    wrapperClasses: ['currency-input'],
                    labelClasses: [''],
                    labelText: '',
                    showRequired: false,
                    isInputRequired: false,
                }}
                input={{
                    id: 'aptcAmount',
                    isInputRequired: true,
                    type: INPUT_TYPES.TEXT,
                    value: values.aptcAmount,
                    disabled: values.planLevel === PlAN_LEVEL.CATASTROPHIC,
                    dataTestId: 'aptcAmount',
                    name: 'aptcAmount',
                    placeholder: '',
                }}
                actions={{
                    handleChange: e => onAptcChange(e),
                }}
                maskOptions={{
                    allowDecimal: true,
                    prefix: '',
                    decimalLimit: '2',
                    integerLimit: 10,
                    includeThousandsSeparator: false,
                    allowLeadingZeroes: true,
                }}
                showIcon={true}
            />
        </StyledField>
    );
};

export default EnrollmentAPTCAmounField;
